<template>
  <div class="footer_big_container">
    <div class="footer_container">
      <ul class="pc">
        <li>
          <h3>{{$t("footer.problems.FAQs_and_process.title")}}</h3>
          <p class="tz" @click="routerLinks(0,0)">{{$t("footer.problems.FAQs_and_process.list_1")}}</p>
          <p class="tz" @click="routerLinks(1,0)">{{$t("footer.problems.FAQs_and_process.list_2")}}</p>
          <p class="tz" @click="routerLinks(2,0)">{{$t("footer.problems.FAQs_and_process.list_3")}}</p>
        </li>
        <li>
          <h3>{{$t("footer.problems.auction_rules.title")}}</h3>
          <p class="tz" @click="routerLinks(0,1)">{{$t("footer.problems.auction_rules.list_1")}}</p>
          <p class="tz" @click="routerLinks(1,1)">{{$t("footer.problems.auction_rules.list_2")}}</p>
          <p class="tz" @click="routerLinks(2,1)">{{$t("footer.problems.auction_rules.list_3")}}</p>
          <p class="tz" @click="routerLinks(3,1)">{{$t("footer.problems.auction_rules.list_4")}}</p>
        </li>
        <li>
          <h3>{{$t("footer.problems.other_FAQs.title")}}</h3>
          <p class="tz" @click="routerLinks(0,2)">{{$t("footer.problems.other_FAQs.list_1")}}</p>
          <p class="tz" @click="routerLinks(1,2)">{{$t("footer.problems.other_FAQs.list_2")}}</p>
        </li>

        <!-- <li >
					<h3>合作伙伴</h3>
					
						
								<p ><a :href="link.url" target="_blank" class="tz" v-for="link in links" style="color: #595959;">{{link.title}}<br></a></p>
					
				</li> -->
        <li>
          <h3>合作伙伴</h3>
          <p><a :href="link.url" target="_blank" class="tz" v-for="(link, index) in links" :key="index" style="color: #595959;">{{ link.title }}<br></a></p>
        </li>
        <li>
          <h3>{{$t("footer.problems.official_wechat.title")}}</h3>
          <img class="QR" src="@/assets/images/ma.jpg">
        </li>
        <li>
          <h3>小程序 </h3>
          <img class="QR" src="@/assets/images/lite.jpg">
        </li>
        <li>
          <!-- <h3 class="about_us" @click="routerLinks(0,3)">{{$t("footer.problems.about_us.title")}}</h3> -->
          <p>{{$t("footer.problems.about_us.list_1")}}</p>
          <p class="c_red">{{$t("footer.problems.about_us.list_2")}}</p>
          <p>{{$t("footer.problems.about_us.list_3")}}</p>
        </li>
      </ul>
      <div class="mobile">
        <div class="problem">
          <router-link to="/problem">
            <h3>{{$t("footer.problems.FAQs_and_process.title")}}</h3>
            <img src="@/assets/images/goto.png">
          </router-link>
        </div>
        <div class="contact">
          <div class="left">
            <img class="QR" src="@/assets/images/ma.jpg">
            <h3>{{$t("footer.problems.official_wechat.title")}}</h3>
          </div>
          <div class="right">
            <!-- <h3 class="about_us">{{$t("footer.problems.about_us.title")}}</h3> -->
            <p>{{$t("footer.problems.about_us.list_1")}}</p>
            <p class="c_red">{{$t("footer.problems.about_us.list_2")}}</p>
            <p>{{$t("footer.problems.about_us.list_3")}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="beian">
      <div class="t_line">
        <router-link to="/">{{$t("footer.keep_on_record.nav.home")}}</router-link>|
        <router-link to="/biaodi?type=全部">{{$t("header.nav.subject")}}</router-link>|
        <router-link to="/subjects">{{$t("footer.keep_on_record.nav.notice")}}</router-link>|
        <!-- <router-link to="/biaodi?type=%E5%85%A8%E9%83%A8&page=1&status=3">成交案例</router-link>| -->
        <!-- <router-link to="/paimaigonggao">{{$t("header.nav.notice")}}</router-link>| -->
        <router-link to="/pai">拍品送拍</router-link>|
        <router-link to="/contact">{{$t("header.nav.about_us")}}</router-link>
      </div>
      <ul class="b_line">
        <li><a href="http://beian.miit.gov.cn">{{$t("footer.keep_on_record.License_No")}}：吉B2-20200092</a></li>
        <li><a href="http://beian.miit.gov.cn">{{$t("footer.keep_on_record.MIIT")}}：吉ICP备20000476号-1</a></li>
        <li>{{$t("footer.keep_on_record.copyright")}}</li>&nbsp;
        <li class="footer-cert-item">
          <a id="_xinchacharenzheng_cert_vip_ssl" style="text-decoration:none;" target="_blank" href="https://xyt.xinchacha.com/getpcInfo?sn=1509074405106257920&certType=8&url=*.paijie.com">
            <img class="footer-cert-img" src="https://xyt.xinchacha.com/img/icon/icon8.png" alt="网站安全证书" style="width:144px;height:40px;">
          </a>
        </li>

        <li class="footer-cert-item">
          <a id="_xinchacharenzheng_cert_vip_kexinweb" style="text-decoration:none;" target="_blank" href="https://xyt.xinchacha.com/pcinfo?sn=1511637807770390528&certType=6">
            <img class="footer-cert-img" src="https://program.xinchacha.com/xyt/icon3.png" alt="可信网站认证" style="width:127px;height:40px;">
          </a>
        </li>

      </ul>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  inject: ['reload'],
  props: {
    msg: String
  },
  data () {
    return {
      links: []
    }
  },
  created () {
    this.axios.get("https://api.paijie.com/links")
      .then((response) => {
        if (response.data.error.code == 0) {
          this.links = response.data.links;
        }
        // console.log(this.links)
      })
      .catch(() => { });
  },
  watch: {

  },
  methods: {
    routerLinks: function (curLi, curUl) {
      if (this.$route.path == '/problem') {
        this.$router.push({
          path: this.$route.path,
          query: {
            curLi: curLi, curUl: curUl
          }
        })
        this.reload();
      } else {
        this.$router.push({
          path: '/problem',
          query: {
            curLi: curLi, curUl: curUl
          }
        })
      }
    }
  }
}
</script>
